import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';

const OnboardNowPrompt = ({ closeToast, message }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleOnboardNow = () => {
    closeToast(); // Close the toast notification
    navigate('/onboard-buyer');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 1,
        bgcolor: 'white',
      }}
    >
      <Typography
        variant='body1'
        sx={{ mb: 2 }}
      >
        {message}
      </Typography>
      <Button
        variant='outlined'
        color='primary'
        onClick={handleOnboardNow}
        sx={{
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        Onboard Now
      </Button>
    </Box>
  );
};

export default OnboardNowPrompt;
